// extracted by mini-css-extract-plugin
export default {"page":"subscriptions_page__63H4j","container":"subscriptions_container__CAngG","title":"subscriptions_title__qCpip","content":"subscriptions_content__wdCTo"};